// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1ZEGT","disabled":"FileBtn_disabled__3lI0s","warn":"FileBtn_warn__2Y3g8","fade":"FileBtn_fade__1RgV6"};